var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconCircleBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14030",
    "data-name": "Group 14030",
    transform: "translate(-2925.165 -3231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13694",
    "data-name": "Group 13694",
    transform: "translate(2925 3231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11046",
    "data-name": "Group 11046",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(0.165)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "edit_FILL0_wght300_GRAD0_opsz24_1_",
    "data-name": "edit_FILL0_wght300_GRAD0_opsz24 (1)",
    d: "M146.922-809.424h.631l4.729-4.729-.631-.631-4.729,4.729Zm7-5.282-1.723-1.708.666-.666a.745.745,0,0,1,.547-.225.745.745,0,0,1,.547.225l.622.622a.764.764,0,0,1,.233.539.709.709,0,0,1-.217.539Zm-.554.562-5.487,5.487h-1.723v-1.724l5.487-5.487Zm-1.4-.326-.313-.313.631.631Z",
    transform: "translate(2782.856 4052.318)",
    fill: "#024fe0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconCircleBlue);
export default __webpack_public_path__ + "static/media/edit-icon-circle-blue.344d9732a530b25254f54f2c9a394663.svg";
export { ForwardRef as ReactComponent };